import {ColorSwatch as MantineColorSwatch} from '@mantine/core';

/**
 * Color sample swatch — design-layer pass-through over Mantine `ColorSwatch`.
 * @registry Pass-through Mantine ColorSwatch; import this instead of @mantine/core outside src/design.
 */
export const ColorSwatch = MantineColorSwatch;
